import queryString from "query-string";

import {
    GET_TRAINING_TYPE
} from "@/api/master-data/training-type/training-type";

const state = {
    trainingType: [],
};

const mutations = {
    setTrainingType: (states, payload) => {
        states.trainingType = payload;
    },
};

const actions = {
    getTrainingType: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_TRAINING_TYPE(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setTrainingType", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setTrainingType", []);
            }
            throw err;
        }
    },
};

const getters = {
    TrainingType: (states) => states.trainingType,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};